export const REG_FORM_CONTROL_TYPE = {
    INPUT: 1,
    SELECT: 2,
    PASSWORD: 3,
    DATEPICKER: 4,
    ATTACHMENT: 5,
    CHECKBOX: 6
}

export const REG_FORM_CONTROL_RULE = {
    REQUIRED: 1 << 0,
    OPTIONAL: 1 << 1,
    HIDDEN: 1 << 2,
}

export const REG_FORM_CONTROL_NAME = {
    USERNAME: "UserName",
    EMAIL: "Email",
    PASSWORD: "Password",
    CONFIRM_PASSWORD: "ConfirmPassword",
    FIRST_NAME: "FirstName",
    LAST_NAME: "LastName",
    PHONE_NUMBER: "PhoneNumber",
    COUNTRY: "Country",
    STATE: "State",
    CITY: "City",
    ADDRESS: "Address",
    ZIPCODE: "ZipCode",
    CONTACT_CHANNEL: "ContactChannel",
    CONTACT_CHANNEL_NAME: "ContactChannelName",
    ADDITIONAL_INFO: "AdditionalInfo",
    TARGET_MARKET: "TargetMarket",
    TRAFFIC_SOURCE: "TrafficSource",
    CURRENCY_CODE: "CurrencyCode",
    PAYMENT_METHOD: "PaymentMethod",
    RECEIVE_NEWSLETTER: "ReceiveNewsletter",
    REGULATOR_AFFILIATE_ID: "RegulatorAffiliateId",
    AFFILIATE_AGREEMENT_ID: "AffiliateAgreementId"
}

export const AFFILIATE_REG_TYPE = {
	SELF_SIGN_UP: 1 << 0,
	BY_AFFILIATE_MANAGER: 1 << 1,
};